import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { render } from 'react-dom';
import axios from 'axios';
import App from './containers/App/App';
import logOutExpiredSession from './shared/functions/session';

axios.defaults.baseURL = process.env.REACT_APP_DOMAIN_URL;
axios.defaults.withCredentials = true;

// What FOSRest's AccessDeniedListener answers (403) when a call in its zones fails
// access_control, i.e. when the session is gone. Some endpoints send their own 403
// (the review rule on pings), so this text alone is not proof: /user decides.
const ACCESS_DENIED = 'You do not have the necessary permissions';

// One /user check shared by every call that failed at the same time (a page fires
// several), so one alert. Resolves true while the session is alive; a network error
// counts as alive, only an answered refusal logs out.
let sessionCheck = null;
const checkSession = () => {
  if (!sessionCheck) {
    sessionCheck = axios.get('/user')
      .then(response => typeof response.data === 'object')
      .catch(error => !error.response)
      .then((alive) => {
        if (alive) sessionCheck = null; else logOutExpiredSession();
        return alive;
      });
  }
  return sessionCheck;
};

// The app checks the login once at boot (App.checkLoginStatus) and then moves between
// pages without reloading, so a session that dies mid-visit left every page showing
// the 403 above. /user itself is App's call (and this check's), never re-checked here.
axios.interceptors.response.use(
  response => response,
  (error) => {
    const { response, config } = error;
    if (
      response
      && response.status === 403
      && response.data
      && response.data.message === ACCESS_DENIED
      && !(config && config.url === '/user')
    ) {
      // Session gone: the page stays as it is while the browser goes to /logout
      return checkSession().then(alive => (alive ? Promise.reject(error) : new Promise(() => {})));
    }

    return Promise.reject(error);
  },
);

render(
  <App />,
  document.getElementById('root'),
);
